// Neutrals
const black = "#000";
const gray1 = "#E0E0E0";
const gray2 = "#F6F6F6";

// Colors
const green = "#C9E9CB";
const blue = "#BEDAEC";
const yellow = "#FAEED2";
const paleYellow = "#FDFAF2";
const darkBlue = "#448DC3";
const paleBlue = "#e3f2fd";
const red = "#DC776D";

export const colors = {
  // Neutrals
  black,
  gray1,
  gray2,

  // Colors
  green,
  blue,
  yellow,
  paleYellow,
  darkBlue,
  paleBlue,
  red,

  // UI Colors
  inputActiveColor: darkBlue,
  errorColor: red,
  textColor: black,
};

export const typography = {
  fontFamilyDefault: '"Museo Sans", Menlo, sans-serif',
  fontSizeDefault: 16,
};

export const sizes = {
  siteMaxWidth: 700,
};
